import React from 'react'
import { CONTENT_TYPE, IVariationContainer } from 'marketing-site/@types/generated/contentful'
import { MutinyVariationComponent } from 'marketing-site/src/components/experiments'
import { renderTransformedComponent } from 'marketing-site/lib/transformedComponents'

export function ContentfulMutinyVariationContainer(
  variationContainer: IVariationContainer & { children?: React.ReactNode },
): React.ReactElement | null {
  const { variations, meta, experimentId } = variationContainer.fields

  const getVariationName = (id?: string) => {
    if (!meta) return
    const availableVariations = Object.keys(meta)
    return availableVariations.filter((item) => id === meta[item]).shift()
  }

  const transformVariations = (content: IVariationContainer['fields']['variations']) => {
    const variations = content?.map((item) => {
      const variationName = getVariationName(item.sys.id)
      const contentTypeId = item.sys.contentType?.sys.id as CONTENT_TYPE
      return { name: variationName, component: renderTransformedComponent(contentTypeId, item) }
    })
    return variations
  }

  return (
    <MutinyVariationComponent
      variations={transformVariations(variations)}
      experimentId={experimentId}
    />
  )
}
